import "core-js/modules/es.object.freeze.js";
export var Days = Object.freeze({
  MONDAY: {
    value: 1,
    translation: storelocator.i18n.monday
  },
  TUESDAY: {
    value: 2,
    translation: storelocator.i18n.tuesday
  },
  WEDNESDAY: {
    value: 3,
    translation: storelocator.i18n.wednesday
  },
  THURSDAY: {
    value: 4,
    translation: storelocator.i18n.thursday
  },
  FRIDAY: {
    value: 5,
    translation: storelocator.i18n.friday
  },
  SATURDAY: {
    value: 6,
    translation: storelocator.i18n.saturday
  },
  SUNDAY: {
    value: 7,
    translation: storelocator.i18n.sunday
  }
});